var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AB00",
    d: "M16.188 3.786v16.257c0 1.819 1.256 2.832 2.586 2.832 1.231 0 2.586-.862 2.586-2.832V3.91c0-1.668-1.232-2.71-2.586-2.71-1.355 0-2.587 1.15-2.587 2.586Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E37400",
    d: "M9.414 12.037v8.005c0 1.82 1.256 2.833 2.586 2.833 1.232 0 2.586-.862 2.586-2.833V12.16c0-1.667-1.231-2.709-2.586-2.709-1.354 0-2.586 1.15-2.586 2.586ZM5.227 22.875a2.586 2.586 0 1 0 0-5.172 2.586 2.586 0 0 0 0 5.172Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/GoogleAnalytics.d4aca7bf007a7c3251fa4a173c017a0a.svg";
export { ForwardRef as ReactComponent };